import { render, staticRenderFns } from "./FollowUDPStream.vue?vue&type=template&id=2427fedc&scoped=true&"
import script from "./FollowUDPStream.vue?vue&type=script&lang=js&"
export * from "./FollowUDPStream.vue?vue&type=script&lang=js&"
import style0 from "./FollowUDPStream.vue?vue&type=style&index=0&id=2427fedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427fedc",
  null
  
)

export default component.exports